import React, { useEffect, useRef, useState } from 'react';
import { Carousel } from 'antd';
import Header from '@/views/header';
import Footer from '@/views/footer';
import oneDImg from '@/assets/home/result/交通运输1@2x.png';
import oneHImg from '@/assets/home/result/交通运输2@2x.png';
import twoDImg from '@/assets/home/result/石油1.png';
import twoHImg from '@/assets/home/result/石油石化1@2x.png';
import threeDImg from '@/assets/home/result/电力通讯1@2x.png';
import threeHImg from '@/assets/home/result/电力通讯2.png';
import fourDImg from '@/assets/home/result/危险作业1@2x.png';
import fourHImg from '@/assets/home/result/危险作业2@2x.png';
import fiveDImg from '@/assets/home/result/航天军工1@2x.png';
import fiveHImg from '@/assets/home/result/航天军工2@2x.png';
import sixDImg from '@/assets/home/result/仓储安全1@2x.png';
import sixHImg from '@/assets/home/result/仓储安全2@2x.png';
import smallOne from '@/assets/home/result/one.png';
import smallTwo from '@/assets/home/result/two.png';
import smallThree from '@/assets/home/result/three.png';
import smallFour from '@/assets/home/result/four.png';
import smallFive from '@/assets/home/result/five.png';
import smallSix from '@/assets/home/result/six.png';
import leftBtn from '@/assets/home/result/left.png';
import rightBtn from '@/assets/home/result/rig.png';

import gsLockImg from '@/assets/home/resultGs/lockimg.png';

import sosImg from '@/assets/home/resultGs/sos.png';
import g4Img from '@/assets/home/resultGs/g4.png';
import locationImg from '@/assets/home/resultGs/location.png';
import psImg from '@/assets/home/resultGs/ps.png';

import g1Imgs from '@/assets/home/resultGs/1.png';
import g2Imgs from '@/assets/home/resultGs/2.png';
import g3Imgs from '@/assets/home/resultGs/3.png';
import g4Imgs from '@/assets/home/resultGs/4.png';
import g5Imgs from '@/assets/home/resultGs/5.png';
import g6Imgs from '@/assets/home/resultGs/6.png';

import './index.css';

const AccordionItem = ({ data, index, isActive, onHover }) => {
  return (
    <div
      className={`accordion-item ${isActive ? 'active' : ''}`}
      onMouseEnter={() => onHover(index)}
      onMouseLeave={() => onHover(null)}
    >
      <div
        className="default-image"
        style={{ backgroundImage: `url(${data.defaultImg})` }}
      >
        <div className="d-title-ctn">
          <div className="d-enTitle">{data.enTitle}</div>
          <div className="d-cnTitle">{data.cnTitle}</div>
        </div>
        <img src={data.smallImg} className="smallIcon" />
      </div>

      <div
        className="hover-image"
        style={{ backgroundImage: `url(${data.hoverImg})` }}
      >
        <div className="title-ctn">
          <div className="enTitle">{data.enTitle}</div>
          <div className="cnTitle">{data.cnTitle}</div>
        </div>
        <div
          className="ctn-desc"
          dangerouslySetInnerHTML={{ __html: data.desc }}
        ></div>
        <img src={data.smallImg} className="smallIcon" />
      </div>
    </div>
  );
};

const Reult = () => {
  const homeTwoRef = useRef(null);

  const [twoTopHeight, setTwoTopHeight] = useState(0);
  const [threeTopHeight, setThreeTopHeight] = useState(0);

  const [activeIndex, setActiveIndex] = useState(0);
  const [startIndex, setStartIndex] = useState(0);

  const [sfqData, setSfqData] = useState([
    {
      defaultImg: oneDImg,
      hoverImg: oneHImg,
      enTitle: 'Transportation industry',
      cnTitle: '交通运输行业',
      desc: '在铁路、航空、远洋、公路运输过程中对集装箱、包装柜、重点设备等均需要使用锁具进行安全保障。',
      smallImg: smallOne,
    },
    {
      defaultImg: twoDImg,
      hoverImg: twoHImg,
      enTitle: 'Oil and petrochemical industry',
      cnTitle: '石油石化行业',
      desc: '在油田生产管理中，通过锁具对重点要害部位挂牌上锁。如输气输油管线阀门、控制柜、计量仪表校验、重点测、钻、采设备的管理。<br/> 对无人值守场站、机房、电力设备的防盗防拆以及油气输运环节中的防盗措施，均需要使用具 有无线报警功能的施封锁，确保正常运行。',
      smallImg: smallTwo,
    },
    {
      defaultImg: threeDImg,
      hoverImg: threeHImg,
      enTitle: 'Power and telecommunications',
      cnTitle: '电力通讯行业',
      desc: '无人值守输变电站、无人值守通讯基站数量庞大。在传统防盗防破坏的安全需求之外，远程授权管理开锁功能将使生产管理更加便捷。',
      smallImg: smallThree,
    },
    {
      defaultImg: fourDImg,
      hoverImg: fourHImg,
      enTitle: 'Hazardous operations sector',
      cnTitle: '危险作业领域',
      desc: '各类施工作业现场，需要关断各类阀门或电闸才能具备施工条件，这些阀闸在施工过程中是绝对禁止开启的。使用具有无线报警功能的施封锁，能够进一步加强现场管理，一旦有违规开启发生即可无线预警，避免安全事故的发生。',
      smallImg: smallFour,
    },
    {
      defaultImg: fiveDImg,
      hoverImg: fiveHImg,
      enTitle: 'Aerospace and military industry',
      cnTitle: '航天军工领域',
      desc: '针对航天、军工、军队等保密级别较高的场所，锁具既要确保其严格的保密性，又要确保在充分授权后的及时开启，尤其在武器库等重点保障场所，多人授权开锁管理要求等级高具有无线报警功能的施封锁能够高效、安全的发挥辅助管理作用。',
      smallImg: smallFive,
    },
    {
      defaultImg: sixDImg,
      hoverImg: sixHImg,
      enTitle: 'Warehouse safety',
      cnTitle: '仓储安全',
      desc: '通过智能报警施封锁管控库房，避免非授权人员进入库房。一旦锁具遭到破坏立即发出报警信息，保障物资安全。对于重要物资库房，实行授权开锁模式。库房需要多人授权才能开启，确保重要物资安全。',
      smallImg: smallSix,
    },
  ]);

  const [cardData, setCardData] = useState([
    {
      img: g1Imgs,
      oneText: '多种开锁方式',
      twoText: '支持指纹、蓝牙、4G远程多种形式开锁。',
    },
    {
      img: g2Imgs,
      oneText: '智能报警',
      twoText: '内置智能报警，遇破坏、温度等异常立即上报。',
    },
    {
      img: g3Imgs,
      oneText: '多级&远程授权',
      twoText: '仅有权限用户可开锁，支持远程与多级多人同意后开锁。',
    },
    {
      img: g4Imgs,
      oneText: '开关锁定位',
      twoText: '开关锁即记录GPS/北斗并上报，后台地图可见。',
    },
    {
      img: g5Imgs,
      oneText: '防水防爆&低功耗',
      twoText: '防护等级IP65，防爆等级为本安 Ex ib llC T3 Gb。',
    },

    {
      img: g6Imgs,
      oneText: '太阳能充电',
      twoText: '内置太阳能充电模块，可通过光照自动补充电量。',
    },
  ]);

  const handleHover = (index) => {
    setActiveIndex(index !== null ? index : startIndex);
  };

  const handleNext = () => {
    setStartIndex((prevIndex) => (prevIndex + 1) % sfqData.length);
  };

  const handlePrev = () => {
    setStartIndex((prevIndex) =>
      prevIndex === 0 ? sfqData.length - 4 : prevIndex - 1
    );
  };

  useEffect(() => {
    document.title = '鸿凯瑞达-产品';
    const { top } = homeTwoRef.current.getBoundingClientRect();
    setTwoTopHeight(top);
    const threeRef = homeTwoRef.current.getBoundingClientRect();
    setThreeTopHeight(threeRef.top);

    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad';
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os';
    var bIsMidp = sUserAgent.match(/midp/i) == 'midp';
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4';
    var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb';
    var bIsAndroid = sUserAgent.match(/android/i) == 'android';
    var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce';
    var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile';
    if (
      bIsIpad ||
      bIsIphoneOs ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsAndroid ||
      bIsCE ||
      bIsWM
    ) {
      window.location.replace('/m/result');
    }
  }, []);

  return (
    <div>
      <div className="home-one">
        <Header pageName="resultgs" />
        <div className="bg-top-img-gs">
          <div className="top-img-text-gs">
            <div className="en-title" style={{ color: '#083865' }}>
              Intelligent alarm steel shackle padlock
            </div>
            <div className="cn-title" style={{ color: '#083865' }}>
              智能报警挂锁
            </div>
          </div>
          <div className="top-center-text-gs" style={{ color: '#083865' }}>
            “鸿凯瑞达智能报警挂锁”是一款具有智能报警功能的挂锁，同时具有指纹开锁、手机蓝牙开锁、手机远程开锁等功能。锁具智能检测锁梁断裂、锁体受到破坏、锁具温度过高等则立即发送报警信息给监控管理人员，避免非法开启等异常带来的经济损失和管理风险。
          </div>

          <div style={{ display: 'flex' }}>
            <div style={{ marginLeft: 200 }}>
              <div className="topquan">锌合金外壳</div>
              <div className="bottomquan">防腐耐用</div>
            </div>
            <img src={gsLockImg} className="gsImg" />
            <div>
              <div className="topquan" style={{ marginLeft: 200 }}>
                多项认证检测
              </div>
              <div className="bottomquan">防水防爆</div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-two-result-gs" ref={homeTwoRef}>
        <div className="two-ctn">
          <img src={sosImg} className="twoImg" />
          <div className="twoctn">多种报警</div>
        </div>
        <div className="two-ctn">
          <img src={g4Img} className="twoImg" />
          <div className="twoctn">远程控制</div>
        </div>
        <div className="two-ctn">
          <img src={locationImg} className="twoImg" />
          <div className="twoctn">定位上报</div>
        </div>
        <div className="two-ctn">
          <img src={psImg} className="twoImg" />
          <div className="twoctn">加密算法</div>
        </div>
      </div>
      <div className="home-threeTwo-result-gs">
        <div className="en-title">Product features</div>
        <div className="title">产品特点</div>
        <div className="title-line"></div>

        <div className="lll-container">
          {cardData.map((reward, index) => (
            <div className="lll-card" key={index}>
              <img src={reward.img} className="lll-img" />
              <div className="lll-onetext">{reward.oneText}</div>
              <div className="lll-twotext">{reward.twoText}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="home-three-result-gs">
        <div className="en-title">Application field</div>
        <div className="title">多个应用领域</div>
        <div className="title-line"></div>

        {startIndex !== 0 && (
          <img src={leftBtn} className="leftBtn" onClick={handlePrev} />
        )}
        <div className="accordion">
          {sfqData.slice(startIndex, startIndex + 4).map((reward, index) => (
            <AccordionItem
              key={index}
              index={index}
              isActive={activeIndex === index}
              onHover={handleHover}
              data={reward}
            />
          ))}
        </div>
        {startIndex < sfqData.length - 4 && (
          <img src={rightBtn} className="rightBtn" onClick={handleNext} />
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Reult;
